import React from 'react';
import './TextArea.css'
import { view } from 'react-easy-state';

export default view((props) => (
  <textarea className={
    (props.className ? props.className : '')
  } onChange={props.onChange} value={props.value} placeholder={props.placeholder} rows={props.rows}>{props.children}</textarea>
))